import i18next from '~/i18n'

// Pending queries pass `count: undefined`. There is no bare `audience` key,
// only `audience_one` / `audience_other`, so that lookup would emit missingKey.
// `exists` resolves the key without that event.
export const audiencePaginationLabel = (count?: number) =>
  i18next.exists('rm:audience', { count })
    ? i18next.t('rm:audience', { count })
    : ''
